import { gql } from '@apollo/client';
import { AI_ASSISTANT_SESSION_FRAGMENT } from '../queries/aiAssistant';

// SPA-facing mutations, all returning AiAssistantSession via the shared fragment. Async model:
// start/refine are synchronous; post-select ops (selectCycle/chooseFrequency/submitImpacts) return
// `processing` and the result lands via websocket → refetch; abandon/accept return directly.

export const AI_ASSISTANT_START_SESSION = gql`
  mutation aiAssistantStartSession($userInput: String!, $assessmentId: UxId, $workspaceId: UxId) {
    aiAssistantStartSession(userInput: $userInput, assessmentId: $assessmentId, workspaceId: $workspaceId) {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;

export const AI_ASSISTANT_REFINE = gql`
  mutation aiAssistantRefine($sessionId: String!, $userInput: String!) {
    aiAssistantRefine(sessionId: $sessionId, userInput: $userInput) {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;

export const AI_ASSISTANT_SELECT_CYCLE = gql`
  mutation aiAssistantSelectCycle($sessionId: String!, $cycleId: String!) {
    aiAssistantSelectCycle(sessionId: $sessionId, cycleId: $cycleId) {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;

export const AI_ASSISTANT_CHOOSE_FREQUENCY = gql`
  mutation aiAssistantChooseFrequency($sessionId: String!, $chosenTimes: Int!, $chosenYears: Int!) {
    aiAssistantChooseFrequency(sessionId: $sessionId, chosenTimes: $chosenTimes, chosenYears: $chosenYears) {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;

export const AI_ASSISTANT_SUBMIT_IMPACTS = gql`
  mutation aiAssistantSubmitImpacts($sessionId: String!, $selectedImpactIds: [String!]!) {
    aiAssistantSubmitImpacts(sessionId: $sessionId, selectedImpactIds: $selectedImpactIds) {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;

export const AI_ASSISTANT_ABANDON = gql`
  mutation aiAssistantAbandon($sessionId: String!) {
    aiAssistantAbandon(sessionId: $sessionId) {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;

export const AI_ASSISTANT_ACCEPT = gql`
  mutation aiAssistantAccept($sessionId: String!) {
    aiAssistantAccept(sessionId: $sessionId) {
      ...AiAssistantSessionParts
    }
  }
  ${AI_ASSISTANT_SESSION_FRAGMENT}
`;
